export default {"frames": [

{
	"filename": "01_butterfly.png",
	"frame": {"x":1,"y":1,"w":257,"h":269},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":158,"y":52,"w":257,"h":269},
	"sourceSize": {"w":512,"h":512}
},
{
	"filename": "02_butterfly.png",
	"frame": {"x":260,"y":1,"w":251,"h":234},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":17,"y":175,"w":251,"h":234},
	"sourceSize": {"w":512,"h":512}
},
{
	"filename": "03_butterfly.png",
	"frame": {"x":1,"y":272,"w":290,"h":160},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":96,"y":161,"w":290,"h":160},
	"sourceSize": {"w":512,"h":512}
}],
"meta": {
	"app": "https://www.codeandweb.com/texturepacker",
	"version": "1.0",
	"image": "butterfly.js.png",
	"format": "RGBA8888",
	"size": {"w":512,"h":512},
	"scale": "1",
	"smartupdate": "$TexturePacker:SmartUpdate:654e27161e46186636fcc3fb8e5007bd:135ca0e37174435bd288ab5609792308:dd5260a4236ebd26a32f44a6db68cb77$"
}
}
